import { Entity } from '@/store/shared/entity'
import LogisticsCostEntity from './logisticscost'
export default class LogisticsCost extends Entity<number>{
    logisticsConfirmStatus:string;
    shippingNumber:string;
    shipmentDate:Date;
    customerName:string;
    exchangeRate:number;
    realExchangeRate:number;
    rmbExchangeRate:number;
    allTotalAmount:number;
    salesType:string;
    owner:string;
    recordDto:Array<LogisticsCostEntity>=new Array<LogisticsCostEntity>();
}